import { put, takeEvery } from 'redux-saga/effects';
import { sendApiSettings, getApiSettings, putApiZapierKey, putApiZapierDisconnect } from './api';
import { SEND_API_SETTINGS, GET_API_SETTINGS, PUT_API_KEY, API_ZAPIER_DISCONNECT } from './constants';
import { sendApiSettingsSuccess, getApiSettingsSuccess, putApiKeySuccess, putApiZapierDisconnectSuccess } from './actions';

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{result: *, type: string}>>}
 */
function* apiSettingsSend( obj ) {
    const serverResponse = yield sendApiSettings( obj.form );
    if ( serverResponse ) {
        yield put( sendApiSettingsSuccess( serverResponse ) );
    }
}

/**
 *
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{result: *, type: string}>>|*, void, *>}
 */
function* apiSettingsGet( ) {
    const serverResponse = yield getApiSettings();
    if ( serverResponse ) {
        yield put( getApiSettingsSuccess( serverResponse ) );
    }
}

function* apiZappierKey( ) {
    const serverResponse = yield putApiZapierKey();
    if ( serverResponse ) {
        yield put( putApiKeySuccess( serverResponse ) );
    }
}
function* apiZappierDisconnect( ) {
    const serverResponse = yield putApiZapierDisconnect();
    if ( serverResponse ) {
        yield put( putApiZapierDisconnectSuccess( serverResponse ) );
    }
}


/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchSendApi() {
    yield takeEvery( SEND_API_SETTINGS, apiSettingsSend );
    yield takeEvery( GET_API_SETTINGS, apiSettingsGet );
    yield takeEvery( PUT_API_KEY ,apiZappierKey );
    yield takeEvery( API_ZAPIER_DISCONNECT , apiZappierDisconnect );
}

export default watchSendApi;
